module.exports = __webpack_public_path__ + "img/photo_certificates.48edba90.jpg";